<template>
  <div class="game">
    <div class="game-ready" v-if="isReady">
      <div class="game-ready-circle">{{readyText[readyTime]}}</div>
      <div class="game-ready-arrow"></div>
      <div class="game-ready-text">上划拆红包</div>
    </div>
    <div class="game-end" v-if="isEnd">
      <div class="game-end-container">
        <div class="game-end-redpacket">
          <div class="game-end-money">{{random_price}}+?元</div>
        </div>
        <div class="game-end-btn" @click="share">邀好友拆红包</div>
        <div class="game-end-close" @click="close"></div>
      </div>
    </div>
    <div class="game-container">
      <div class="game-count">
        <div class="game-count-number">x {{countNunber}}</div>
      </div>
      <div class="game-drop">
        <div class="game-drop-img"></div>
      </div>
      <div class="game-redpacket"></div>
      <div
        v-for="(item, index) in packs"
        :key="item"
        class="game-redpacket redpacketFadeout"
        @animationend="removeRedpacket(index)"
      ></div>
      <div class="game-footer"></div>
      <div class="game-footer-redpacket"></div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import api from '@/api/api';
import { getAppShareUrl } from '@/utils'; 

export default {
  name: 'game',
  data() {
    return {
      isReady: true,
      isStart: false,
      isEnd: false,
      readyTime: 0,
      readyText: ['3s', '2s', '1s', 'GO'],
      countNunber: 10,
      redpacketY: 0,
      redpacketFadeout: false,
      packs: [],
      lock: false,
      moveY: 0,
      startY: 0,
      isShowGuide: false,
      count: 0
    };
  },
  computed: {
    ...mapGetters(['random_price', 'rp_id'])
  },
  mounted() {
    this.timerId = `t-${Date.now()}`;
    localStorage.setItem('icbc_game_timer_id', this.timerId);
    this.countDownTime = setInterval(this.countDown, 1000);
    document.addEventListener('touchmove', this.touchMove);
    document.addEventListener('touchstart', this.touchStart);
    document.addEventListener('touchend', this.touchEnd);
  },
  destroyed() {
    clearInterval(this.countDownTime);
    clearInterval(this.gameTime);
  },
  methods: {
    ...mapActions(['appGameRp']),
    showGuide() {
      this.isShowGuide = true;
    },
    closeShowGuide() {
      this.isShowGuide = false;
    },
    removeRedpacket(e) {
      this.packs.splice(e, 1);
    },
    touchMove(e) {
      if (this.isStart) {
        this.moveY = e.changedTouches[0].clientY;
        if (this.moveY < this.startY) {
          this.redpacketY = this.startY - this.moveY;
        }
        if (this.redpacketY > 50) {
          this.redpacketFadeout = true;
          if (!this.lock) {
            this.packs = this.packs.concat(Date.now());
            this.countNunber += 10;
          }
          this.lock = true;
        }
      }
    },
    touchStart(e) {
      this.startY = e.changedTouches[0].clientY;
      this.redpacketFadeout = false;
    },
    touchEnd() {
      this.lock = false;
    },
    async countDown() {
      if (this.readyTime === 3) {
        this.isStart = true;
        this.isReady = false;
        clearInterval(this.countDownTime);

        this.gameTime = setInterval(async () => {
          this.count += 1;
          console.log(this.count);
          if (this.count >= 10) {
            clearInterval(this.gameTime);
            if (this.timerId !== localStorage.getItem('icbc_game_timer_id')) {
              return;
            }
            let res = null;
            try {
              res = await api.postAppGameRp();
              console.log('postAppGameRp', JSON.stringify(res));
            } catch (err) {
              if (this.$route.path === '/game') {
                alert(err.msg);
                this.$router.replace('/');
              }
              window.Sentry && window.Sentry.captureException(err);
            }
            this.appGameRp(res)
              .then(() => {
                this.isEnd = true;
                this.isStart = false;
              })
              .catch(err => {
                this.isEnd = true;
                this.isStart = false;
                window.Sentry && window.Sentry.captureException(err);
              });
          }
        }, 1000);
      }
      this.readyTime += 1;
    },
    close() {
      this.$router.replace('/');
    },
    share() {
      var pngUrl =
        'https://v.icbc.com.cn/userfiles/Resources/WAP/eshapp/shiyi/logo.png';
      var shareUrl = fiboSDK.dealUrl(
        getAppShareUrl(this.rp_id)
      );
      var title = '新春e起拆红包';
      var content = '你来拆，我来拆，齐齐来夺2019元开年大礼';
      var shareInfo = {
        PNGUrl: pngUrl,
        ShareUrl: shareUrl,
        Title: title,
        Content: content
      };
      shareInfo = JSON.stringify(shareInfo);
      window.hybrid_app.share(shareInfo);
      fiboSDK.btnClick('invite-friend-btn', '邀好友拆红包');
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/index.scss';

.game {
  @include set-image('../assets/images/game-bg.jpg');
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  &-ready {
    @include set-image('../assets/images/game-mask.png');
    background-size: 100% 100%;
    position: fixed;
    width: 100vw;
    height: 100vh;
    z-index: 99;
    &-circle {
      @include set-image('../assets/images/game-circle.png');
      @include set-size(193, 193);
      @include set-lt(279, 326);
      @include set-property(font-size, 70);
      display: flex;
      justify-content: center;
      align-items: center;
      color: #ddb251;
    }
    &-arrow {
      @include set-image('../assets/images/game-arrow.png');
      @include set-size(78, 95);
      @include set-lt(336, 809);
      animation: arrowUp 0.8s ease 0s infinite;
    }
    &-text {
      @include set-property(font-size, 36.8);
      @include set-lt(278, 960);
      color: #f3ce70;
    }
  }
  &-end {
    @include set-image('../assets/images/game-mask.png');
    background-size: 100% 100%;
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 99;
    display: flex;
    justify-content: center;
    align-items: center;
    &-container {
      @include set-size(750, 1182);
      position: relative;
    }
    &-money {
      @include set-property(font-size, 52.8);
      @include set-size(459, 0);
      @include set-lt(0, 118);
      text-align: center;
      font-weight: 600;
      color: #800118;
    }
    &-redpacket {
      @include set-image('../assets/images/game-end-redpacket.png');
      @include set-size(459, 751);
      @include set-lt(160, 100);
    }
    &-btn {
      @include set-image('../assets/images/home-redpacket-btn.png');
      @include set-size(258, 60);
      @include set-lt(256, 890);
      @include set-property(font-size, 31.4);
      @include set-property(line-height, 60);
      color: #81010a;
    }
    &-close {
      @include set-image('../assets/images/game-end-close.png');
      @include set-size(55, 55);
      @include set-lt(353, 990);
    }
  }
  &-container {
    @include set-size(750, 1182);
    position: relative;
  }
  &-count {
    @include set-image('../assets/images/game-count-borad.png');
    @include set-size(685, 225);
    @include set-lt(33, 0);
    position: fixed;
    z-index: 50;
    &-number {
      @include set-lt(363, 140);
      @include set-property(font-size, 38);
      color: #ddb251;
    }
  }
  &-drop {
    @include set-size(647, 1000);
    @include set-lt(52, 100);
    position: fixed;
    &-img {
      @include set-image('../assets/images/game-bg-drop.png');
      @include set-size(647, 1423.4);
      @include set-lt(0, 0);
      background-repeat: repeat-y;
      animation: dropImgAni 1s linear infinite;
    }
  }
  &-redpacket {
    @include set-image('../assets/images/game-redpacket.png');
    @include set-size(422, 561);
    @include set-rb(164, 0);
    z-index: 10;
    &.redpacketFadeout {
      animation: redpacketFadeout 1s;
    }
  }
  &-footer {
    @include set-image('../assets/images/game-footer.png');
    @include set-size(750, 654);
    @include set-rb(0, -400);
    z-index: 30;
    &-redpacket {
      @include set-image('../assets/images/game-footer-redpacket.png');
      @include set-size(665, 420);
      @include set-lt(45, 620);
    }
  }
}

@media (min-aspect-ratio: 750/1182) {
  .game {
    &-container {
      height: 100%;
    }
  }
}

@keyframes dropImgAni {
  from {
    background-position-y: 0;
  }

  to {
    background-position-y: 86.26667vw;
  }
}

@keyframes redpacketFadeout {
  from {
    transform: translateY(-10%);
    opacity: 1;
  }
  to {
    transform: translateY(-120%);
    opacity: 0;
  }
}

@keyframes arrowUp {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(-20px);
  }
}
</style>



